import React from 'react'
import Button from '@mui/material/Button';
import HomeIcon from '@mui/icons-material/Home';

const ReturnToHome = () => {
    const location = window.location.href
    const handleBack = () => {
        if(location.includes('deg')){
            window.location.href = '/degenti'
        }else{
            window.location.href = '/'
        }
    }

  return (
    <div className='button-home'>
        <div style={{display:'flex',flexDirection:'row',height:20,alignItems:'center'}}>
        <Button onClick={handleBack}><HomeIcon sx={{mr:1}}/>Home</Button> 
        </div>
    </div>
  )
}

export default ReturnToHome